import { onReady } from "./runtime/on-ready.js";

onReady(() => {
  const btn = document.querySelector('[data-js="hello-btn"]');
  if (!btn) return;
  btn.addEventListener("click", () => alert("Hello from Home!"));
});
